/*
  CRO 17 Sep 2026 — open the header dropdowns on hover.

  The founder reported the Catalog menu "takes so long to load". Measured: it holds 16 links,
  no images, no animation, and opens in ~70ms. Nothing is loading. The real cause is Dawn's
  default — a <details> menu that only opens on CLICK, so hovering does nothing and the menu
  feels broken or slow.

  This opens it on hover for mouse users only, with a short close delay so moving the pointer
  diagonally into the panel doesn't snap it shut. Touch and keyboard are untouched: coarse
  pointers keep click-to-open, and Dawn's own summary/Escape handling still runs.
*/
(() => {
  const FINE_POINTER = window.matchMedia('(hover: hover) and (pointer: fine)');
  const WIDE = window.matchMedia('(min-width: 990px)');
  const CLOSE_DELAY = 180;

  const setOpen = (details, open) => {
    if (details.open === open) return;
    details.open = open;
    const summary = details.querySelector('summary');
    if (summary) summary.setAttribute('aria-expanded', String(open));
  };

  const bind = (menu) => {
    const details = menu.querySelector('details');
    if (!details || details.dataset.hoverBound) return;
    details.dataset.hoverBound = 'true';
    let timer = null;

    menu.addEventListener('mouseenter', () => {
      if (!FINE_POINTER.matches || !WIDE.matches) return;
      clearTimeout(timer);
      setOpen(details, true);
    });

    menu.addEventListener('mouseleave', () => {
      if (!FINE_POINTER.matches || !WIDE.matches) return;
      clearTimeout(timer);
      timer = setTimeout(() => setOpen(details, false), CLOSE_DELAY);
    });
  };

  const bindAll = () => document.querySelectorAll('header-menu').forEach(bind);
  document.addEventListener('DOMContentLoaded', bindAll);
  bindAll();
})();
